//components/SiteNaviSticky/index.jsx

import React from 'react'
import Link from 'gatsby-link'
import TopBar from '../TopBar';
import { Container, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, Button } from 'reactstrap';
import LogoSvg from '../LogoSvg';
import './SiteNaviSticky.scss';

class SiteNaviSticky extends React.Component {

	constructor(props) {
		super(props);  

    this.state = {
			isOpen: false,
			scrolledPast: '',
			scrollPos: 0,
    };

		this.toggle = this.toggle.bind(this);
		this.scrollToTopAndToggle = this.scrollToTopAndToggle.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
	}

	toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
	}

	scrollToTopAndToggle() {
		window.scrollTo(0, 0);
		this.toggle();
	}

		

	handleScroll(event) {
		const opaqueHeight = window.innerHeight - 75;
		(window.pageYOffset < 65)
			? this.setState({ scrolledPast: '' })
			: window.pageYOffset < 280 
				? this.setState({ scrolledPast: 'first' })
				: window.pageYOffset < opaqueHeight
					? this.setState({ scrolledPast: 'second' })
					: this.setState({ scrolledPast: 'third' });
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

  render() {
		const { location, title, scrollPos } = this.props
    return (
			<div className="sticky-nav-wrap">
				{/* MOBILE HEADER */}
				<Navbar color="faded" light fixed='top' className="mobile-header">
					<NavbarToggler onClick={this.toggle} />
					<Collapse isOpen={this.state.isOpen} navbar>
						<Nav className="ml-auto" navbar>
							<NavItem>
								<Link to="#" className="nav-link" onClick={this.scrollToTopAndToggle}>HOME</Link>
							</NavItem>
							<NavItem>
								<Link to="#about2" className="nav-link" onClick={this.toggle}>ABOUT US</Link>
							</NavItem>
							<NavItem>
								<Link to="#attorneys2" className="nav-link" onClick={this.toggle}>OUR ATTORNEYS</Link>
							</NavItem>
							<NavItem>
								<Link to="#contact2" className="nav-link" onClick={this.toggle}>CONTACT</Link>
							</NavItem>
						</Nav>
					</Collapse>
				</Navbar>
				{/* DESKTOP HEADER */}
				<div className={`desktop-header ${ this.state.scrolledPast }`}>
					<div>
						<div className="menu-items">
							<a href="#about" className="my-nav-link"><span className="nav-link-desktop">ABOUT US</span></a>
							<a href="#attorneys" className="my-nav-link"><span className="nav-link-desktop">OUR ATTORNEYS</span></a>
							<a href="#contact" className="my-nav-link"><span className="nav-link-desktop">CONTACT</span></a>
						</div>
					</div>
				</div>
			</div>
    )
  }
}

export default SiteNaviSticky



// WEBPACK FOOTER //
// ./src/components/SiteNaviSticky/index.jsx